/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Settings_Tab_ConflictsInputs */



/**
* | output |
* | --- |
* | "Conflicts" |
*
* @param {Project_Settings_Tab_ConflictsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_settings_tab_conflicts = /** @type {((inputs?: Project_Settings_Tab_ConflictsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Settings_Tab_ConflictsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konflikte")
	return /** @type {LocalizedString} */ ("Conflicts")
});